import { Booking, ConversationMessage } from 'swagger/models';

export const userNameDisplay = (message: ConversationMessage, booking: Booking, userId: string) => {
  // TODO @vstlouis model needs inspecting
  // @ts-ignore
  if (message?.sender?.user_is_old_captain && message?.sender?.user_type === 'captain') {
    return '';
  }
  // TODO @vstlouis model needs inspecting
  // @ts-ignore
  if (message.type === 'booking_special_offer' && userId === booking?.owner?.id) {
    return booking?.renter?.first_name;
  }
  return message?.sender?.first_name;
};

export function isValidUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}
